/**
 * New IDs for old entities like items and sellers look like this: "f_123" - Old ones do not include vertical prefix.
 * This function will return the numeric ID whether or not the id being considered has the vertical prefix.
 * Extend module.modelHelper onto your models to get this method.
 */

'use strict';

function _getLegacyId(id) {
    var legacyId = id.split('_')[1];
    return legacyId || id;
}

module.exports = {
    from : function (id) {
        return _getLegacyId(id);
    },
    modelHelper : function () {
        return this.get('id') ? _getLegacyId(this.get('id')) : null;
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/legacyId.js
// module id = 2033
// module chunks = 62